import React, { useState, useEffect } from "react";
import "../../../index.scss";
import "./ServicesForm.scss";
import ServiceDefaultImg from "../../../assets/market-icons/producto.jpg";
import { getCategoriesSimple } from "../../../services/utilsCategories/utilsCategories";
import { getFranchiseTypes } from "../../../services/utilsFranchiseType/utilsFranchiseType";
import { getSalePointsOfOrganization } from "../../../services/utilsFranchise/utilsFranchise";
import { InputAdornment } from '@mui/material';
import { Link, useLocation, useParams } from "react-router-dom";
import EditIcon from "../../../assets/icons/white-create-24px.svg";
import { FormattedMessage } from "react-intl";
import AutocompleteInput from "../../../components/Autocomplete/AutocompleteInput";
import {
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Snackbar,
} from "@material-ui/core";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import { Alert } from "@material-ui/lab";

//This is for mobile
import { styled, Box } from "@mui/system";
import Switch from "@mui/material/Switch";

import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { getAllSalePointType } from "../../../services/utilsSalePointType";
import CreatableSelect from "react-select/creatable";
import TagInput from "../../../components/TagsInput/TagInput";
import {
  associateTagWithService,
  getTagsOfOrganization,
  modifyTagWithService,
} from "../../../services/utilsTags";
import { set } from "date-fns";
import { useHistory } from "react-router-dom";

import { postService, putService } from "../../../services/utilsService/utilsService";
import { getServiceById } from "../../../services/utilsService/utilsService";
import { getServiceCategoriesSimple } from "../../../services/utilsCategories/utilsCategories";

const filter = createFilterOptions();

const style = {
  position: "absolute",
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "grid",
  placeItems: "center",
};

const ServicesForm = () => {
  /**
   * Variables & Constans
   */
  const [service, setService] = useState({
    name: "",
    sku: "",
    description: "",
    point_of_sale: 0,
    price: 0.0,
    fk_product_category: 0,
    validity: 0,
    limit_type: 0,
    limit: 0,
    limit_time: 0,
    limit_active: true,
    quantity: 0,
  });

  const [imgSource, setImgSource] = useState(ServiceDefaultImg);

  const [loading, setLoading] = useState(true);

  const [formTitle, setFormTitle] = useState("createNewService");

  const [submitLabel, setSubmitLabel] = useState("createServiceLbl");

  const [inEditSize, setInEditSize] = useState("section-body col");

  const [submitted, setSubmitted] = useState(false);

  const [submittedDelete, setSubmittedDelete] = useState(false);

  const [serviceCategory, setServiceCategory] = useState("");

  const [serviceCategoriesList, setServiceCategoriesList] = useState([]);

  const [salePointList, setSalePointList] = useState([]);

  const [servicePrice, setServicePrice] = React.useState();

  const [disabledSelect, setDisableSelect] = useState(true);

  const [limitType, setLimitType] = useState("");

  const hiddenFileInput = React.useRef(null);

  const urlLocation = useLocation();
  const { id } = useParams();

  let newProfilePicture;

  const [open, setOpen] = React.useState(false);

  const [openModal, setOpenModal] = useState(false);

  const [openErrorModal, setErrorModal] = useState(false);

  const [selectedSps, setSelectedSps] = useState([]);

  const [tags, setTags] = useState();

  const [selectedTags, setSelectedTags] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [loadingDelete, setLoadingDelete] = useState(false);

  const [snackbarMessage, setSnackbarMessage] = useState(
    <Alert severity="success">NONE</Alert>
  );
  const [successSnackbar, setSuccessSnackbar] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [deleteAvailable, setDeleteAvailable] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const history = useHistory();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [formEvent, setFormEvent] = useState(null);

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    if (!value || value === "") {
      return "Este campo es obligatorio";
    }
    return "";
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  /**
   * Async calls
   */

  const fetchData = async () => {
    sessionStorage.setItem("prevPage", "ServicesForm");

    try {
      // do all the necessary calls in parallel
      const [categoriesData, salePointsData] = await Promise.all([
        getServiceCategoriesSimple(),
        getSalePointsOfOrganization()
      ]);

      // set base lists
      setServiceCategoriesList(categoriesData["service_categories"]);
      const sptOptions = salePointsData["sale_points"].map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setSalePointList(sptOptions);

      // edit mode, load the service data
      if (urlLocation.pathname.includes("edit")) {
        let serviceId = id || localStorage.getItem("fk_product");
        setFormTitle("editService");
        setDeleteAvailable(true);
        setSubmitLabel("saveServiceLbl");
        setInEditSize("section-body col-7");
        
        const serviceResponse = await getServiceById(serviceId);
        // console.log("getServiceById response:", serviceResponse);
        let serviceData = serviceResponse.product;
        
        setServicePrice(serviceData.sell_price / 100);
        
        // set service data
        setService({
          ...service,
          name: serviceData.name,
          sku: serviceData.sku,
          description: serviceData.description,
          price: serviceData.sell_price / 100,
          quantity: serviceData.quantity,
          limit_active: serviceData.enabled,
          ...(serviceData.point_of_sale && { point_of_sale: serviceData.point_of_sale }),
          ...(serviceData.validity && { validity: serviceData.validity }),
          ...(serviceData.limit_type && { limit_type: serviceData.limit_type }),
          ...(serviceData.limit && { limit: serviceData.limit }),
          ...(serviceData.limit_time && { limit_time: serviceData.limit_time }),
          fk_product_category: serviceData.fk_product_category || 0,
          enabled: serviceData.enabled || false,
        });

        // set selected category
        if (serviceData.product_category) {
          setServiceCategory(serviceData.product_category);
        } else if (serviceData.fk_product_category) {
          const selectedCategory = categoriesData["service_categories"].find(
            cat => cat.id === serviceData.fk_product_category
          );
          if (selectedCategory) {
            setServiceCategory(selectedCategory);
          }
        }

        // set selected sale point
        if (serviceData.point_of_sale && serviceData.point_of_sale !== 0) {
          const selectedSalePoint = salePointsData["sale_points"].find(
            sp => sp.id === serviceData.point_of_sale
          );
          if (selectedSalePoint) {
            setSelectedSps({
              value: selectedSalePoint.id,
              label: selectedSalePoint.name,
            });
          }
        }

        // set limit type
        if (serviceData.limit_type !== undefined && serviceData.limit_type !== null) {
          setLimitType(serviceData.limit_type);
        }

        // set image
        if (serviceData.image && serviceData.image !== "null" && serviceData.image !== "N/A") {
          setImgSource(serviceData.image);
        }
      }

      setLoading(false);
      
    } catch (error) {
      console.error("Error loading data:", error);
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData().then(() => {});
  }, []);

  

  /**
   * Handlers
   */

  const handleEditImageClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChangeLimitType = (event) => {
    setLimitType(event.target.value);
    setService({ ...service, limit_type: event.target.value });
  };

  const getLimitLabel = () => {
    switch (limitType) {
      case 0:
        return "Cantidad límite diaria";
      case 1:
        return "Cantidad límite semanal";
      case 2:
        return "Cantidad límite mensual";
      case 3:
        return "Cantidad límite por minuto";
      default:
        return "Cantidad límite";
    }
  };

  const handleOnImageChange = (event) => {
    const newFile = event.target.files[0];
    if (newFile != null) {
      setService({ ...service, [event.target.name]: event.target.files[0] });
      newProfilePicture = newFile;
      const url = URL.createObjectURL(newProfilePicture);
      setImgSource(url);
    }
  };

  const handleChangeCheckBox = (event) => {
    setService({ ...service, [event.target.name]: event.target.checked });
  };

  const handleReturn = (event) => {
    // console.log("return");
    setOpenDeleteModal(false);
  };

  const handleConfirmDelete = (event) => {
    // console.log("confirm");
    setSubmittedDelete(true);
    setLoadingDelete(true);
    sleep(1000).then((data) => {
      // console.log(data);

      setSuccessSnackbar(true);
      setOpenDeleteModal(false);
      setSnackbarMessage(
        <Alert severity="success">Se ha eliminado el servicio con éxito</Alert>
      );
      sleep(100).then((data) => {
        setOpenSnackbar(true);
        setSubmittedDelete(false);
      });
    });
  };

  const handleChangeOfCategory = (value) => {
    /*if (value) {
      if (value.sale_point_types) {
        let categoryId = value.id;
        let salePointTypes = value.sale_point_types.map((e) => ({
          value: e.sale_point_type.id,
          label: e.sale_point_type.name,
        }));
        setService({
          ...service,
          fk_service_category: categoryId,
          fk_sale_point_types: salePointTypes,
        });
        setSalePointList(salePointTypes);
        setSelectedSpt(salePointTypes);
      } else {
        setDisableSelect(false);
      }
    } else {
      setService({ ...service, fk_sale_point_type: "" });
    }*/
  };

  const handleInputChangeInner = (event) => {
    setService({ ...service, [event.target.name]: event.target.value });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleCloseErrorModal = () => {
    setErrorModal(false);
  };

  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    history.push("/servicios");
  };

  const handleSnackbarClose = (event, reason, success = false) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
    if (successSnackbar) {
      history.push("/servicios");
    }
  };

  const handleDeleteClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenDeleteModal(false);
  };

  const setCloseTime = () => {
    setOpen(false);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const handleDelete = (event) => {
    setSubmittedDelete(true);
    setOpenDeleteModal(true);
    sleep(1000).then(() => {
      setSubmittedDelete(false);
    });
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffffff',
    boxShadow: 24,
    p: 2.5,
    borderRadius: 2,
  };

  const cancelSubmit = () => {
    setShowConfirmModal(false);
    setFormEvent(null);
  };

  const confirmSubmit = () => {
    setShowConfirmModal(false);
    if (!formEvent) return;
    
    setSubmitted(true);
    let formDataBody = new FormData();

    // edit mode?
    const isEditMode = urlLocation.pathname.includes("edit");
    const serviceId = id || localStorage.getItem("fk_product");

    // Required fields
    formDataBody.append("name", service.name || "");
    formDataBody.append("sku", service.sku || "");
    formDataBody.append("description", service.description || "");
    formDataBody.append("sell_price", service.price ? parseInt(service.price) * 100 : 0); // Convertir a centavos
    formDataBody.append("quantity", service.quantity || 0);
    formDataBody.append("enabled", service.limit_active ? 1 : 0);
    
    // edit mode, add the service id
    if (isEditMode && serviceId) {
      formDataBody.append("fk_product", serviceId);
    }
    
    // fk_product_category from serviceCategory
    if (serviceCategory) {
      if (serviceCategory.id) {
        formDataBody.append("fk_product_category", serviceCategory.id);
      } else if (serviceCategory.inputValue) {
        // new category created by the user
        formDataBody.append("service_category_name", serviceCategory.inputValue);
      } else if (serviceCategory.title) {
        formDataBody.append("service_category_name", serviceCategory.title);
      } else if (serviceCategory.name) {
        formDataBody.append("service_category_name", serviceCategory.name);
      }
    }
    
    // fk_organization from local storage
    const organizationId = localStorage.getItem("fk_organization");
    if (organizationId) {
      formDataBody.append("fk_organization", organizationId);
    }

    // Image file if exists
    if (service.file && typeof service.file !== "string") {
      // keep the original file extension
      const originalExtension = service.file.name.split('.').pop().toLowerCase();
      const fileName = `servicePicture.${originalExtension}`;
      formDataBody.append("file", service.file, fileName);
    }

    // other optional fields - only send if they have meaningful values
    if (service.point_of_sale && service.point_of_sale !== 0) {
      formDataBody.append("point_of_sale", service.point_of_sale);
    }
    if (service.validity && service.validity !== "" && service.validity !== 0) {
      formDataBody.append("validity", service.validity);
    }
    if (service.limit_type !== null && service.limit_type !== undefined && service.limit_type !== "") {
      formDataBody.append("limit_type", service.limit_type);
    }
    if (service.limit !== null && service.limit !== undefined) {
      formDataBody.append("limit", service.limit);
    }
    if (service.limit_time && service.limit_time !== 0) {
      formDataBody.append("limit_time", service.limit_time);
    }


    // use the correct service call according to the mode
    const serviceCall = isEditMode ? putService(formDataBody) : postService(formDataBody);

    serviceCall
      .then((data) => {
        // console.log("Respuesta del servicio:", data);
        if (data.error) {
          throw new Error(data.error);
        }
        
        setSubmitted(false);
        
        //behaviors according to the mode
        if (isEditMode) {
          // edit mode: show snackbar
          setOpen(true);
        } else {
          // creation mode: show modal
          setOpenModal(true);
        }
        
        // save service id if it is returned
        if (data.service && data.service.id) {
          localStorage.setItem("fk_product", data.service.id);
        }
      })
      .catch((error) => {
        // console.error(`Error al ${isEditMode ? 'actualizar' : 'crear'} el servicio:`, error);
        setSubmitted(false);
        setErrorMessage(error.message || `Error al ${isEditMode ? 'actualizar' : 'crear'} el servicio`);
        setErrorModal(true);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormEvent(event);
    setShowConfirmModal(true);
  };


  const validateRequiredFields = () => {
    // edit mode, only validate that there is at least one name (minimum field)
    const isEditMode = urlLocation.pathname.includes("edit");
    
    if (isEditMode) {
      // edit mode, only require that the name is not empty
      return service.name && service.name.trim() !== "";
    }
    
    // creation mode, validate all required fields
    const requiredFields = {
      name: service.name,
      sku: service.sku,
      description: service.description,
      price: service.price,
      quantity: service.quantity,
      serviceCategory: serviceCategory,
      // only validate limit if limitType is selected (including value 0 for "Daily") 
      ...(limitType !== "" && limitType !== null && limitType !== undefined && {
        limit: service.limit
      }),
      // limit: limitType ? service.limit : true,
    };

    return Object.values(requiredFields).every(value => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === 'object' && value !== null) {
        return value.id || value.inputValue || value.title || value.name;
      }
      return value !== undefined && value !== null && value !== "" && value !== 0;
    });
  };

  /**
   * Render elements
   */
  return (
    <div className="row" id="container-service-form">
      <main className={inEditSize} id="service-info">
        <Snackbar
          open={openSnackbar}
          autoHideDuration={5000}
          onClose={handleSnackbarClose}
        >
          {snackbarMessage}
        </Snackbar>
        <h1 className="section-title">
          <FormattedMessage id={formTitle} />
        </h1>
        <article>
          {!loading && (
            <form onSubmit={handleSubmit} className="row g-3 mt-3">
              <div className="d-flex justify-content-center mb-4">
                <img className="profile-picture" src={imgSource} alt="Avatar" />
                <div className="icon-container d-flex justify-content-center align-items-center">
                  <img
                    className="icon"
                    src={EditIcon}
                    alt="edit_icon"
                    onClick={handleEditImageClick}
                  />
                </div>
              </div>
              <input
                type="file"
                ref={hiddenFileInput}
                onChange={handleOnImageChange}
                name="file"
                hidden="hidden"
                accept=".jpg, .jpeg, .png, .gif"
              />
              <div className="row my-2">
                <div className="col-6">
                  <TextField
                    required={!urlLocation.pathname.includes("edit")}
                    className="form-control"
                    label={<FormattedMessage id="nameLbl" />}
                    value={service.name ? service.name : ""}
                    name="name"
                    onChange={handleInputChangeInner}
                    onBlur={handleBlur}
                    error={Boolean(errors.name && touched.name)}
                    helperText={touched.name && errors.name}
                  />
                </div>
                <div className="col-6">
                  <TextField
                    className="form-control"
                    label="SKU"
                    // type="number"
                    value={service.sku ? service.sku : ""}
                    name="sku"
                    onChange={handleInputChangeInner}
                    onBlur={handleBlur}
                    required={!urlLocation.pathname.includes("edit")}
                    error={Boolean(errors.sku && touched.sku)}
                    helperText={touched.sku && errors.sku}
                  />
                </div>
              </div>

              <div className="row my-2">
                <div className="col-12">
                  <TextField
                    className="form-control"
                    label={<FormattedMessage id="descriptionLbl" />}
                    multiline
                    value={service.description ? service.description : ""}
                    name="description"
                    onChange={handleInputChangeInner}
                    onBlur={handleBlur}
                    required={!urlLocation.pathname.includes("edit")}
                    error={Boolean(errors.description && touched.description)}
                    helperText={touched.description && errors.description}
                  />
                </div>

                {/* <div className="col-6 mb-3">
                  <label className="form-label" htmlFor="timezoneInput">
                    <FormattedMessage id="franchiseLbl" />
                  </label>
                  {salePointList && (
                    <AutocompleteInput
                      options={salePointList}
                      selectedOptions={selectedSps}
                      setSelected={(selected) => {
                        setSelectedSps(selected);
                        setService({ ...service, point_of_sale: selected ? selected.value : 0 });
                      }}
                      isClearable={false}
                      isSearchable={false}
                      isMulti={false}
                      placeholder={"Selecciona un punto de venta"}
                    />
                  )}
                </div> */}
              </div>
              <div className="row my-2">
                <div className="col-6">
                  <TextField
                    className="form-control"
                    label="Precio"
                    type="number"
                    multiline
                    value={service.price ? service.price : ""}
                    name="price"
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^0-9]/g, "");
                      handleInputChangeInner({ target: { name: e.target.name, value: numericValue } });
                    }}
                    inputProps={{ min: 0, step: 1 }}
                    onBlur={handleBlur}
                    required={!urlLocation.pathname.includes("edit")}
                    error={Boolean(errors.price && touched.price)}
                    helperText={touched.price && errors.price}
                  />
                </div>
                <div className="col-6">
                  <TextField
                    required={!urlLocation.pathname.includes("edit")}
                    className="form-control"
                    label="Cantidad"
                    value={service.quantity ? service.quantity : ""}
                    name="quantity"
                    type="number"
                    onChange={handleInputChangeInner}
                    onBlur={handleBlur}
                    error={Boolean(errors.quantity && touched.quantity)}
                    helperText={touched.quantity && errors.quantity}
                  />
                </div>
              </div>
              <div className="row my-2">
                  <div className="col-6">
                    <Autocomplete
                      value={serviceCategory}
                      onChange={(event, newValue) => {
                        handleChangeOfCategory(newValue);
                        if (typeof newValue == "string") {
                          setServiceCategory({
                            title: newValue,
                          });
                        } else if (newValue && newValue.inputValue) {
                          setServiceCategory({
                            title: newValue.inputValue,
                          });
                        } else {
                          setServiceCategory(newValue);
                        }
                      }}
                      onBlur={() => {
                        setTouched((prev) => ({ ...prev, serviceCategory: true }));
                        const isEditMode = urlLocation.pathname.includes("edit");
                        setErrors((prev) => ({
                          ...prev,
                          serviceCategory:
                            !isEditMode && (!serviceCategory || serviceCategory === "") ? "Este campo es obligatorio" : ""
                        }));
                      }}
                      filterOptions={(options, params) => {
                        const filtered = filter(options, params);
                        if (params.inputValue !== "") {
                          filtered.push({
                            inputValue: params.inputValue,
                            // name: `Add "${params.inputValue}"`,
                          });
                        }
                        return filtered;
                      }}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      id="category-input"
                      options={serviceCategoriesList}
                      getOptionLabel={(option) => {
                        if (typeof option === "string") {
                          return option;
                        }
                        if (option.inputValue) {
                          return option.inputValue;
                        }
                        if (option.title) {
                          return option.title;
                        }
                        return option.name;
                      }}
                      renderOption={(option) => (
                        <React.Fragment>
                          <div>
                            {option.name}
                            <br />
                            <p className="option_subtitle">
                              {option["sale_point_type"] ? option["sale_point_type"].name : ""}
                            </p>
                          </div>
                        </React.Fragment>
                      )}
                      freeSolo
                      renderInput={(params) => (
                        <TextField
                          required={!urlLocation.pathname.includes("edit")}
                          {...params}
                          label={<FormattedMessage id="categoryLbl" />}
                          error={Boolean(errors.serviceCategory && touched.serviceCategory)}
                          helperText={touched.serviceCategory && errors.serviceCategory}
                        />
                      )}
                    />
                  </div>

                <div className="col-6">
                  <TextField
                    className="form-control"
                    label="Periodo de vigencia (días)"
                    type="number"
                    value={service.validity ? service.validity : ""}
                    name="validity"
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^0-9]/g, "");
                      handleInputChangeInner({ target: { name: e.target.name, value: numericValue } });
                    }}
                    inputProps={{ min: 0, step: 1 }}
                    // InputProps={{
                    //   endAdornment: <InputAdornment position="end">días</InputAdornment>
                    // }}
                  />
                </div>
                
              </div>

              <div className="row my-2">
                <div className={`col-${limitType === 3 ? "3" : "6"}`}>
                  <label className="form-label" htmlFor="limitTypeInput">
                    Frecuencia del límite
                  </label>
                  <Select className="w-100" value={limitType} name="limit_type" id="limitTypeInput" onChange={handleChangeLimitType}>
                  <MenuItem value="">Seleccione una opción</MenuItem>
                    <MenuItem value={0}>Diario</MenuItem>
                    <MenuItem value={1}>Semanal</MenuItem>
                    <MenuItem value={2}>Mensual</MenuItem>
                    <MenuItem value={3}>Otro (minutos)</MenuItem>
                  </Select>
                </div>
                {limitType === 3 && (
                <div className="col-3">
                  <TextField
                    required={!urlLocation.pathname.includes("edit")}
                    className="form-control"
                    label="Frecuencia en minutos"
                    value={service.limit_time ? service.limit_time : ""}
                    name="limit_time"
                    onChange={handleInputChangeInner}
                    onBlur={handleBlur}
                    error={Boolean(errors.limit_time && touched.limit_time)}
                    helperText={touched.limit_time && errors.limit_time}
                  />
                </div>
                )}
                <div className="col-6">
                  {/* <TextField
                    className="form-control"
                    label="Cantidad límite"
                    value={service.limit ? service.limit : ""}
                    name="limit"
                    onChange={handleInputChangeInner}

                  /> */}
                                     <TextField
                     className="form-control"
                     label={getLimitLabel()}
                     type="number"
                     value={service.limit ? service.limit : ""}
                     name="limit"
                     onChange={(e) => {
                       const numericValue = e.target.value.replace(/[^0-9]/g, "");
                       handleInputChangeInner({ target: { name: e.target.name, value: numericValue } });
                     }}
                     onBlur={handleBlur}
                     required={!urlLocation.pathname.includes("edit") && limitType !== "" && limitType !== null && limitType !== undefined}
                     error={Boolean(errors.limit && touched.limit && limitType !== "" && limitType !== null && limitType !== undefined)}
                     helperText={touched.limit && errors.limit && limitType !== "" && limitType !== null && limitType !== undefined ? errors.limit : ""}
                     inputProps={{ min: 0, step: 1 }}
                   />
                </div>
                <div className="col-6" style={{ paddingTop: "30px" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        required={!urlLocation.pathname.includes("edit")}
                        checked={service.limit_active}
                        name="limit_active"
                        onChange={handleChangeCheckBox}
                      />
                    }
                    label={<FormattedMessage id="visiblelbl" />}
                  />
                </div>
              </div>
              <div className="row justify-content-end">
                <div className="col-6">
                </div>
                <div className="col-6 d-flex justify-content-end">
                  <Link className="" to="/servicios">
                    <button className="btn btn-outline-primary m-2">
                      <FormattedMessage id="cancelLbl" />
                    </button>
                  </Link>
                  <button
                    className={`btn m-2 ${submitted || !validateRequiredFields() ? "btn-outline-primary" : "btn-primary"}`}
                    type="button"
                    onClick={handleSubmit}
                    disabled={submitted || !validateRequiredFields()}
                  >
                    {!submitted && <FormattedMessage id={submitLabel} />}
                    {submitted && (
                      <div className="d-flex justify-content-center spinner-container">
                        <div
                          className="spinner-border spinner-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </button>
                </div>
                <Snackbar
                  open={open}
                  autoHideDuration={6000}
                  onClose={handleCloseSuccess}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                >
                  <Alert onClose={handleCloseSuccess} severity="success">
                    <FormattedMessage id="uptadedServiceAlertLbl" />
                  </Alert>
                </Snackbar>
                {/**Let's create the modal */}
                <Modal
                open={showConfirmModal}
                onClose={cancelSubmit}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
              >
                <Box sx={modalStyle}>
                  <Typography id="modal-title" variant="h6" component="h2" className="modal-title-confirm">
                    <FormattedMessage id="confirmSaveTitle" defaultMessage="Guardar servicio" />
                  </Typography>
                  <Typography id="modal-description" sx={{ mt: 2 }} className="modal-confirm-edit">
                    <FormattedMessage 
                      id="confirmSaveServiceMessage" 
                      defaultMessage="¿Estás seguro que deseas guardar los cambios del servicio <b>{name}</b>?" 
                      values={{ 
                        name: service.name,
                        b: (chunks) => <strong>{chunks}</strong> 
                      }} 
                    />
                  </Typography>
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button onClick={cancelSubmit} variant="outlined">
                      <FormattedMessage id="cancelButton" defaultMessage="Cancelar" />
                    </Button>
                    <Button onClick={confirmSubmit} variant="contained">
                      <FormattedMessage id="confirmButton" defaultMessage="Confirmar" />
                    </Button>
                  </Box>
                </Box>
              </Modal>
                {/* Modal to handle error in postservice */}
                <Modal
                  open={openErrorModal}
                  onClose={handleClose}
                  errorMessage={errorMessage}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div className="modal-box-error">
                      <h2 className="modal-title">
                        Ha ocurrido un error
                      </h2>
                      <p className="text-center modal-question">
                        {errorMessage}
                      </p>
                      <div className="text-center modal-options">
                        <button
                          className="modal-option btn btn-primary "
                          onClick={handleCloseErrorModal}
                        >
                          <FormattedMessage id="closelbl" />
                        </button>
                      </div>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={openModal}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div className="modal-box">
                      <h2 className="modal-title">
                        <FormattedMessage id="createdServiceLbl" />
                      </h2>
                      <p className="modal-question">
                        <FormattedMessage id="whatNowLbl" />
                      </p>
                      <div className="text-center modal-options">
                        <Link
                          className="modal-option"
                          to={`/servicios/create`}
                          onClick={() => window.location.reload(false)}
                        >
                          <FormattedMessage id="createOtherServiceLbl" />
                        </Link>

                        <Link
                          className="modal-option"
                          to={`/servicios`}
                        >
                          <FormattedMessage id="returnToServicesLbl" />
                        </Link>
                      </div>
                    </div>
                  </Box>
                </Modal>
                <Modal
                  open={openDeleteModal}
                  onClose={handleDeleteClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div className="modal-box">
                      {!loadingDelete ? (
                        <>
                          <h2 className="modal-title">
                            <FormattedMessage id="deletedServiceLbl" />
                          </h2>
                          <div className="text-center modal-options">
                            <button
                              className="btn btn-custom m-2"
                              onClick={handleReturn}
                            >
                              <FormattedMessage id="returnLbl" />
                            </button>
                            <button
                              className="btn btn-outline-danger m-2"
                              onClick={handleConfirmDelete}
                            >
                              <FormattedMessage id="checkLbl" />
                            </button>
                          </div>
                        </>
                      ) : (
                        <div className="d-flex justify-content-center spinner-container">
                          <div
                            className="spinner-border spinner-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </Box>
                </Modal>
              </div>
            </form>
          )}
          {loading && (
            <div className="d-flex justify-content-center spinner-container">
              <div className="spinner-border spinner-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </article>
      </main>
    </div>
  );
};

const Chips = ({ options, selectedOptions, setSelected, isDisabled }) => {
  const handleChange = (newValue, { action }) => {
    setSelected(newValue);
  };

  const handleCreateOption = (inputValue) => {
    const newOption = { value: 0, label: inputValue };
    setSelected([...selectedOptions, newOption]);
  };

  return (
    <CreatableSelect
      isDisabled={isDisabled}
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      onCreateOption={handleCreateOption}
      isMulti
      isClearable
      isSearchable
      placeholder="Selecciona un punto de venta"
    />
  );
};

export default ServicesForm;

